import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useUtility, Text, Card, Stack } from '@hub-la/design-system';
import LaunchIcon from '@mui/icons-material/Launch';
import { CardUploader } from '../card-uploader/card-uploader.js';

const CustomCover = props => {
  const {
    title,
    description,
    showSnackbar
  } = props;
  const {
    palette
  } = useUtility();
  return jsxs(Fragment, {
    children: [jsx(Text, Object.assign({
      variant: "h3",
      marginBottom: 2
    }, {
      children: title
    })), jsx(Text, Object.assign({
      variant: "body2",
      marginBottom: 4
    }, {
      children: description
    })), jsx(Card, Object.assign({
      variant: "filled",
      hasHover: false,
      marginBottom: 2
    }, {
      children: jsx(CardUploader, {
        fieldName: "customCover",
        hasLoading: true,
        showSnackbar: showSnackbar
      })
    })), jsx(Card, Object.assign({
      variant: "filled",
      hasHover: false
    }, {
      children: jsx("a", Object.assign({
        href: "https://www.canva.com/design/DAFdSsJD-0k/m3P8PQOduQTzCUuF7ruF2Q/view?utm_content=DAFdSsJD-0k&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview",
        target: "_blank",
        rel: "noreferrer"
      }, {
        children: jsxs(Stack, Object.assign({
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
        }, {
          children: [jsx(Text, Object.assign({
            color: "greenSecondary"
          }, {
            children: "Use o nosso Template de capa no Canva"
          })), jsx(LaunchIcon, {
            sx: {
              color: palette('greenSecondary')
            }
          })]
        }))
      }))
    })), jsx(Text, Object.assign({
      textAlign: "center",
      marginTop: 4
    }, {
      children: "Tamanho ideal \u00E9 de 319x498px (9:16)"
    }))]
  });
};

export { CustomCover };
